export const properties = [
  {
    id: 1,
    title: "Urban Serenity Apartment",
    category: "Modern Luxury Residential",
    image: "https://images.unsplash.com/photo-1531971589569-0d9370cbe1e5",
    description: "Stunning modern apartment with premium finishes and city views"
  },
  {
    id: 2,
    title: "Coastal Paradise Villa",
    category: "Luxury Waterfront Property",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750",
    description: "Exclusive villa with private pool and ocean access"
  },
  {
    id: 3,
    title: "Contemporary Heights",
    category: "Modern Commercial Space",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811",
    description: "Premium commercial building with state-of-the-art facilities"
  },
  {
    id: 4,
    title: "Lakeside Estate",
    category: "Luxury Residential Complex",
    image: "https://images.pexels.com/photos/1438832/pexels-photo-1438832.jpeg",
    description: "Exclusive lakefront properties with panoramic views"
  },
  {
    id: 5,
    title: "Modern Elegance Tower",
    category: "Contemporary Architecture",
    image: "https://images.pexels.com/photos/18435276/pexels-photo-18435276.jpeg",
    description: "Geometric design meets luxury living"
  },
  {
    id: 6,
    title: "Pristine White Villa",
    category: "Ultra-Modern Residence",
    image: "https://images.unsplash.com/photo-1613977257365-aaae5a9817ff",
    description: "Minimalist luxury with cutting-edge design"
  },
  {
    id: 7,
    title: "Garden Paradise Estate",
    category: "Luxury Villa with Landscape",
    image: "https://images.pexels.com/photos/29453302/pexels-photo-29453302.jpeg",
    description: "Stunning villa surrounded by lush greenery and private pool"
  }
];

export const services = [
  {
    id: 1,
    title: "Property Sales",
    description: "Expert guidance in buying and selling premium properties with personalized service",
    icon: "Home"
  },
  {
    id: 2,
    title: "Property Management",
    description: "Comprehensive property management services ensuring maximum returns and tenant satisfaction",
    icon: "Building2"
  },
  {
    id: 3,
    title: "Investment Advisory",
    description: "Strategic real estate investment consulting for portfolio growth and wealth creation",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Property Valuation",
    description: "Accurate market valuations backed by extensive research and local market knowledge",
    icon: "Calculator"
  },
  {
    id: 5,
    title: "Luxury Rentals",
    description: "Premium rental properties curated for discerning clients seeking exceptional living spaces",
    icon: "Key"
  },
  {
    id: 6,
    title: "Commercial Leasing",
    description: "Strategic commercial property solutions for businesses looking to expand and thrive",
    icon: "Briefcase"
  }
];

export const team = [
  {
    id: 1,
    name: "Hari Prakash Bhati",
    position: "Founder & CEO",
    image: "https://customer-assets.emergentagent.com/job_built-properties/artifacts/zpq7frcl_WhatsApp%20Image%202026-04-02%20at%201.07.01%20PM.jpeg",
    social: {
      facebook: "#",
      twitter: "#",
      linkedin: "#"
    }
  },
  {
    id: 2,
    name: "Rohit Bhati",
    position: "Managing Director",
    image: "https://customer-assets.emergentagent.com/job_built-properties/artifacts/t390unyw_image%202.png",
    education: [
      {
        degree: "BA LLB",
        institution: "Lloyd Law College",
        year: "2011 - 2016"
      },
      {
        level: "Schooling",
        institution: "Ryan International School"
      }
    ],
    social: {
      facebook: "#",
      twitter: "#",
      linkedin: "#"
    }
  },
  {
    id: 3,
    name: "Mohit Bhati",
    position: "Executive Director",
    image: "https://customer-assets.emergentagent.com/job_built-properties/artifacts/6mllcwdh_image%201.png",
    education: [
      {
        degree: "BTech Civil Engineering",
        institution: "Galgotias College"
      },
      {
        level: "Schooling",
        institution: "DPS School NTPC Dadri"
      }
    ],
    social: {
      facebook: "#",
      twitter: "#",
      linkedin: "#"
    }
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    position: "Business Owner",
    image: "https://images.unsplash.com/photo-1758518727888-ffa196002e59",
    text: "Bhagat Prop Built helped us find the perfect commercial space for our business. Their professionalism and market knowledge are unmatched."
  },
  {
    id: 2,
    name: "Arjun Patel",
    position: "Property Investor",
    image: "https://images.unsplash.com/photo-1758876204244-930299843f07",
    text: "Outstanding investment advisory services. They guided me through every step and helped build a profitable real estate portfolio."
  },
  {
    id: 3,
    name: "Fatima Khan",
    position: "Homeowner",
    image: "https://images.pexels.com/photos/33871730/pexels-photo-33871730.jpeg",
    text: "Found my dream home through Bhagat Prop Built. Their attention to detail and understanding of my needs was exceptional."
  },
  {
    id: 4,
    name: "Michael D'Souza",
    position: "Corporate Executive",
    image: "https://images.pexels.com/photos/3727513/pexels-photo-3727513.jpeg",
    text: "Professional, reliable, and results-driven. They made my property purchase seamless and stress-free."
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Basic",
    price: "2%",
    period: "Commission",
    description: "Perfect for first-time buyers and sellers looking for essential real estate services",
    features: [
      "Property Listing",
      "Market Analysis",
      "Basic Marketing",
      "Documentation Support",
      "Post-Sale Assistance"
    ]
  },
  {
    id: 2,
    name: "Premium",
    price: "3%",
    period: "Commission",
    description: "Comprehensive services for serious buyers and investors seeking premium support",
    features: [
      "Priority Listing",
      "Advanced Marketing",
      "Property Staging",
      "Investment Analysis",
      "6 Months Support"
    ],
    featured: true
  },
  {
    id: 3,
    name: "Elite",
    price: "Custom",
    period: "Package",
    description: "Exclusive white-glove service for luxury properties and high-net-worth clients",
    features: [
      "Exclusive Listings",
      "VIP Marketing Campaign",
      "Concierge Service",
      "Portfolio Management",
      "Lifetime Support"
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: "How long does the property buying process typically take?",
    answer: "The property buying process typically takes 30-60 days from offer acceptance to closing, depending on financing, inspections, and legal procedures. We guide you through each step to ensure a smooth transaction."
  },
  {
    id: 2,
    question: "What are the costs involved in buying a property?",
    answer: "Costs include the property price, stamp duty (varies by state), registration fees, legal fees, and our commission. We provide a detailed breakdown upfront so there are no surprises."
  },
  {
    id: 3,
    question: "Do you handle both residential and commercial properties?",
    answer: "Yes, we specialize in both residential and commercial real estate. Our team has expertise across luxury homes, apartments, villas, office spaces, retail properties, and land development."
  },
  {
    id: 4,
    question: "How do I get started with property investment?",
    answer: "Start with a consultation where we assess your financial goals, risk tolerance, and investment timeline. We then identify suitable properties and provide comprehensive market analysis to help you make informed decisions."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Top 10 Real Estate Investment Tips for 2025",
    category: "Investment Guide",
    author: "Rajesh Bhagat",
    date: "January 15, 2025",
    excerpt: "Discover the most effective strategies for real estate investment in today's market. Learn how to maximize returns and minimize risks.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa"
  },
  {
    id: 2,
    title: "Understanding Property Valuation Methods",
    category: "Market Analysis",
    author: "Priya Sharma",
    date: "January 10, 2025",
    excerpt: "A comprehensive guide to property valuation techniques used by professionals to determine accurate market values.",
    image: "https://images.unsplash.com/photo-1554469384-e58fac16e23a"
  },
  {
    id: 3,
    title: "Luxury Real Estate Market Trends",
    category: "Market Insights",
    author: "Anjali Mehta",
    date: "January 5, 2025",
    excerpt: "Explore the latest trends shaping the luxury real estate market and what they mean for buyers and investors.",
    image: "https://images.unsplash.com/photo-1582407947304-fd86f028f716"
  }
];

export const achievements = [
  {
    year: "2020",
    title: "Excellence in Real Estate",
    description: "Recognized for outstanding service and client satisfaction in luxury property segment"
  },
  {
    year: "2021",
    title: "Top Property Consultancy",
    description: "Awarded for innovative marketing strategies and record-breaking sales volume"
  },
  {
    year: "2023",
    title: "Market Leadership Award",
    description: "Acknowledged as the leading real estate firm in premium property transactions"
  },
  {
    year: "2024",
    title: "Industry Innovation",
    description: "Honored for pioneering digital transformation in real estate services"
  }
];

export const stats = [
  { number: "40+", label: "Years Of Experience" },
  { number: "10000+", label: "Satisfied Clients" }
];